export default class Pricing {
  constructor() {
    this.$form = document.querySelector('.js-pricing-form');
    if (!this.$form) return;

    this.$plans = this.$form.querySelectorAll('.js-pricing-plan');
    this.$planRadios = this.$form.querySelectorAll('.js-pricing-radio');
    this.$billingFrequencyRadioRadios = this.$form.querySelectorAll('.js-pricing-billing-frequency');
    this.$monthlyPrices = this.$form.querySelectorAll('.js-pricing-plan-monthly');
    this.$yearlyPrices = this.$form.querySelectorAll('.js-pricing-plan-yearly');
    this.$allFeatures = document.querySelectorAll('.js-pricing-features');
    this.$allAddOns = document.querySelectorAll('.js-pricing-add-ons');
    this.$addOnCheckboxes = document.querySelectorAll('.js-pricing-add-on-checkbox');
    this.$totalPriceContainer = document.querySelector('.js-pricing-total-price-container');
    this.$totalPrice = document.querySelector('.js-pricing-total-price');
    this.$totalPriceBeforeDiscount = document.querySelector('.js-pricing-total-price-before-discount');
    this.$showAllFeaturesButtons = document.querySelectorAll('.js-pricing-show-all-features');
    this.$featuresTable = document.querySelector('.js-pricing-features-table');
    this.$closeFeaturesTable = document.querySelector('.js-pricing-close-features-table');
    this.$menu = document.querySelector('.js-pricing-menu-list');
    this.$menuLinks = document.querySelectorAll('.js-pricing-menu-link');
    this.$currentMenuLink = document.querySelector('.js-pricing-menu-link.is-current');
    this.$bookDemoButton = document.querySelector('.js-pricing-book-demo-button');

    this.scrollCurrentMenuLinkIntoView();

    this.urlHashes = {
      plan: null,
      frequency: null
    };

    this.loadUrlHash();

    this.$plans.forEach($plan => {
      const $planRadio = $plan.querySelector('.js-pricing-radio');

      $plan.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        this.handlePlanClick($plan);
      });

      if ($planRadio.checked) {
        if (!this.urlHashes.plan) {
          this.urlHashes.plan = $plan.dataset.plan;
          $plan.classList.add('is-selected');
          this.handlePlanChange($plan);
        } else {
          if ($plan.dataset.plan === this.urlHashes.plan) {
            $plan.classList.add('is-selected');
            this.handlePlanChange($plan);
          }
        }
      }
    });

    this.$billingFrequencyRadioRadios.forEach($billingFrequencyRadio => {
      $billingFrequencyRadio.addEventListener('change', (e) => {
        this.handleBillingFrequencyChange(e);
      });

      if (!this.urlHashes.frequency && $billingFrequencyRadio.checked) {
        this.urlHashes.frequency = $billingFrequencyRadio.value;
        this.handleBillingFrequencyChange({ target: $billingFrequencyRadio});
      }
    });

    this.$addOnCheckboxes.forEach($addOnCheckbox => {
      $addOnCheckbox.addEventListener('change', this.handleAddonsChange.bind(this));
    });

    this.$showAllFeaturesButtons.forEach($showAllFeaturesButton => {
      $showAllFeaturesButton.addEventListener('click', this.handleShowAllFeaturesClick.bind(this));
    });

    this.$closeFeaturesTable.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeFeaturesTable();
    });

    this.$allAddOns.forEach($addOn => {
      $addOn.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    })

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        this.closeFeaturesTable();
      }
    });
  }

  handlePlanClick($plan) {
    const $selectedPlanRadio = $plan.querySelector('.js-pricing-radio');

    this.$plans.forEach($plan => {
      const $planRadio = $plan.querySelector('.js-pricing-radio');

      if ($planRadio === $selectedPlanRadio) {
        if (window.innerWidth < 1024 && $selectedPlanRadio.checked) {
          $planRadio.checked = false;
          $plan.classList.remove('is-selected');
        } else {
          $planRadio.checked = true;
          $plan.classList.add('is-selected');
        }
      } else {
        $planRadio.checked = false;
        $plan.classList.remove('is-selected');
      }
    });

    this.handlePlanChange($plan);
  }

  handlePlanChange($plan) {
    const $selectedPlanFeatures = document.querySelector(`.js-pricing-features[data-plan="${$plan.dataset.plan}"]`);
    const $selectedPlanAddOns = document.querySelectorAll(`.js-pricing-add-ons[data-plan="${$plan.dataset.plan}"]`);

    this.$allFeatures.forEach($feature => {
      $feature.classList.add('hidden');
    });

    this.$allAddOns.forEach($addOn => {
      $addOn.classList.add('hidden');
    });

    this.$addOnCheckboxes.forEach($addOnCheckbox => {
      $addOnCheckbox.checked = false;
    });

    $selectedPlanFeatures.classList.remove('hidden');

    if ($plan.classList.contains('is-selected')) {
      $selectedPlanAddOns.forEach($selectedPlanAddOn => {
        $selectedPlanAddOn.classList.remove('hidden');
      });

      this.urlHashes.plan = $plan.dataset.plan;
    } else {
      this.urlHashes.plan = undefined;
    }

    this.updateUrlHash();
    this.updateTotalPrice();
  }

  handleBillingFrequencyChange(e) {
    const { value } = e.target;

    this.$monthlyPrices.forEach($monthlyPrice => {
      return value === 'monthly' ?  $monthlyPrice.removeAttribute('style') : $monthlyPrice.style.display = 'none';
    });

    this.$yearlyPrices.forEach($yearlyPrice => {
      return value === 'annually' ? $yearlyPrice.removeAttribute('style') : $yearlyPrice.style.display = 'none';
    });

    this.urlHashes.frequency = value;
    this.updateUrlHash();
    this.updateTotalPrice();
  }

  handleAddonsChange(e) {
    const $selectedPlanRadio = document.querySelector('.js-pricing-radio:checked');
    const selectedPlan = $selectedPlanRadio.dataset.plan;
    const $selectedPlanAddOns = document.querySelectorAll(`.js-pricing-add-ons[data-plan="${selectedPlan}"]`);
    const $selectedPlanSelectedAddOns = document.querySelectorAll(`.js-pricing-add-ons[data-plan="${selectedPlan}"] .js-pricing-add-on-checkbox:checked`);

    $selectedPlanAddOns.forEach($selectedPlanAddOn => {
      if ($selectedPlanAddOn.dataset.allowMultiple === 'false') {
        const $addOns = $selectedPlanAddOn.querySelectorAll('.js-pricing-add-on-checkbox');

        $addOns.forEach($addOn => {
          if (e.target === $addOn && $addOn.checked) {
            return;
          }

          $addOn.checked = false;
        });

      }
    });

    this.updateTotalPrice();
  }

  handleShowAllFeaturesClick(e) {
    e.stopPropagation();
    e.preventDefault();
    this.$featuresTable.classList.add('is-visible');
    this.$featuresTable.setAttribute('aria-hidden', false);
    document.body.classList.add('scrolling-disabled');
  }

  closeFeaturesTable() {
    this.$featuresTable.classList.remove('is-visible');
    this.$featuresTable.setAttribute('aria-hidden', true);
    document.body.classList.remove('scrolling-disabled');
  }

  updateTotalPrice() {
    const selectedFrequency = (document.querySelector('.js-pricing-billing-frequency:checked')).value;
    const $selectedPlanRadio = document.querySelector('.js-pricing-radio:checked');

    let totalPrice = 0;
    let totalPriceBeforeDiscount = 0;
    let hasSelectedAddOns = false;

    if (!$selectedPlanRadio) {
      this.$totalPriceContainer.classList.add('hidden');
      return;
    }

    this.$totalPriceContainer.classList.remove('hidden');

    const selectedPlan = $selectedPlanRadio.dataset.plan;
    const $selectedPlanAddOns = document.querySelectorAll(`.js-pricing-add-ons[data-plan="${selectedPlan}"]`);
    const $selectedPlanSelectedAddOns = document.querySelectorAll(`.js-pricing-add-ons[data-plan="${selectedPlan}"] .js-pricing-add-on-checkbox:checked`);

    if ($selectedPlanRadio.dataset.hasOwnProperty('isCustom')) {
      this.$totalPriceContainer.classList.add('hidden');
      this.updateBookDemoButtonUrl();
      return;
    }

    this.$totalPriceContainer.classList.remove('hidden');

    $selectedPlanAddOns.forEach($selectedPlanAddOn => {
      const $addOns = $selectedPlanAddOn.querySelectorAll('.js-pricing-add-on-checkbox');
      const $selectedAddOns = $selectedPlanAddOn.querySelectorAll('.js-pricing-add-on-checkbox:checked');

      $selectedAddOns.forEach($selectedAddOn => {
        hasSelectedAddOns = true;

        switch (selectedFrequency) {
          case 'monthly':
            totalPrice = parseInt($selectedAddOn.dataset.totalMonthlyPrice);
            break;
          case 'annually':
            totalPrice = parseInt($selectedAddOn.dataset.totalYearlyPrice);
            break;
        }

        totalPriceBeforeDiscount = parseInt($selectedAddOn.dataset.rrpPrice);
      });

      if ($selectedAddOns.length === $addOns.length) {
        switch (selectedFrequency) {
          case 'monthly':
            totalPrice = parseInt($selectedPlanAddOn.dataset.combinedBundleTotalMonthlyPrice);
            break;
          case 'annually':
            totalPrice = parseInt($selectedPlanAddOn.dataset.combinedBundleTotalYearlyPrice);
            break;
        }

        totalPriceBeforeDiscount = parseInt($selectedPlanAddOn.dataset.combinedBundleRrpPrice);

        return;
      }
    });

    if (!$selectedPlanSelectedAddOns.length) {

      switch (selectedFrequency) {
        case 'monthly':
          totalPrice = parseInt($selectedPlanRadio.dataset.monthlyPrice);
          break;
        case 'annually':
          totalPrice = parseInt($selectedPlanRadio.dataset.annualPrice);
          totalPriceBeforeDiscount = parseInt($selectedPlanRadio.dataset.monthlyPrice);
          break;
      }
    }

    switch (selectedFrequency) {
      case 'monthly':

        if (hasSelectedAddOns) {
          this.$totalPriceBeforeDiscount.classList.remove('hidden');
        } else {
          this.$totalPriceBeforeDiscount.classList.add('hidden');
        }

        this.$totalPrice.innerHTML = `$${totalPrice.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}`;

        this.$totalPriceBeforeDiscount.innerHTML = `$${totalPriceBeforeDiscount.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}`;

        break;
      case 'annually':
        this.$totalPriceBeforeDiscount.classList.remove('hidden');

        this.$totalPrice.innerHTML = `$${totalPrice.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}`;

        this.$totalPriceBeforeDiscount.innerHTML = `$${totalPriceBeforeDiscount.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}`;

        break;
    }

    this.updateBookDemoButtonUrl();
  }

  updateBookDemoButtonUrl() {
    const $selectedPlanRadio = document.querySelector('.js-pricing-radio:checked');
    const selectedPlan = $selectedPlanRadio.dataset.plan;
    const $selectedPlanSelectedAddOns = document.querySelectorAll(`.js-pricing-add-ons[data-plan="${selectedPlan}"] .js-pricing-add-on-checkbox:checked`);

    const addOns = [];
    const query = [];

    $selectedPlanSelectedAddOns.forEach($selectedPlanSelectedAddOn => {
      addOns.push($selectedPlanSelectedAddOn.value);
    });

    const params = {
      'demo_request_intent___add_ons': addOns.join(', '),
      'demo_request_intent___billing_frequency': this.urlHashes.frequency,
      'demo_request_intent___plan': selectedPlan,
      'demo_request_intent___product': window.site.meta.permalink,
    }

    for (var key in params) {
      if (params[key]) {
        query.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
      }
    }

    this.$bookDemoButton.href = `/book-a-demo/${(query.length ? '?' + query.join('&') : '')}`;
  }

  loadUrlHash() {
    const url = new URL(window.location.href);
    const hash = url.hash.replace('#/', '').split('/');
    const keys = Object.keys(this.urlHashes);

    keys.forEach(key => {
      const index = hash.indexOf(key);
      if (index === -1) {
        return;
      }

      this.urlHashes[key] = hash[index + 1];
    });

    this.$plans.forEach($plan => {
      if ($plan.dataset.plan === this.urlHashes.plan) {
        const $planRadio = $plan.querySelector('.js-pricing-radio');
        $planRadio.checked = true;
        this.handlePlanChange($plan);
      }
    });

    this.$billingFrequencyRadioRadios.forEach($billingFrequencyRadio => {
      if ($billingFrequencyRadio.value === this.urlHashes.frequency) {
        $billingFrequencyRadio.checked = true;
        this.handleBillingFrequencyChange({ target: $billingFrequencyRadio });
      }
    });
  }

  updateUrlHash() {
    const url = new URL(window.location.href);
    const keys = Object.keys(this.urlHashes);

    let hash = '';

    keys.forEach(key => {
      if (!this.urlHashes[key]) {
        return;
      }

      hash += `/${key}/${this.urlHashes[key]}`;
    });

    url.hash = hash;

    window.history.replaceState({}, '', url);
  }

  scrollCurrentMenuLinkIntoView() {
    if (!this.$currentMenuLink) return;
    const {left: currentLinkLeft, width: currentLinkWidth } = this.$currentMenuLink.getBoundingClientRect();
    const { width: menuWidth } = this.$menu.getBoundingClientRect();
    this.$menu.scrollLeft = currentLinkLeft + currentLinkWidth / 2 - menuWidth / 2;
  }
}
